import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { CookieModule } from 'ngx-cookie';
import { ClickOutsideModule } from 'ng-click-outside';

import { RiscossioneCoattivaModule } from 'app/modules/riscossione-coattiva/riscossione-coattiva.module';

import { CommonService } from './services/common.service';
import { NativeWindowService } from './services/native-window.service';
import { DbService } from './services/db.service';
import { FilterBoxService } from './services/filter-box.service';
import { ContribuentiService } from './services/contribuenti.service';
import { UtentiService } from './services/utenti.service';
import { ComuniService } from './services/comuni.service';

import { DataService } from './services/data.service';
import { LocaleService } from './services/locale.service';
import { AvanzaPraticheService } from './services/avanza-pratiche.service';
import { SocketService } from './services/socket.service';
import { AuthService } from './services/auth.service';
import { JossoService } from './services/josso.service';
import { TableExporterService } from './services/table-exporter.service';

import { SimpleMQ } from 'ng2-simple-mq';
/*  Interceptor	*/
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RCInterceptor } from './interceptors/rc.interceptor';

/* Pipe */
import { FilterPipe } from './pipes/filter.pipe';

/* Directive */
import { FloatingTableHeaderDirective } from './directive/floating-table-header.directive';
import { RouterModule, Routes } from '@angular/router';

import { AppComponent } from './app.component';

const appRoutes: Routes = [
    { path: 'uncertificated', loadChildren: 'app/modules/riscossione-coattiva/core.module#CoreModule' },
    { path: 'check-access', loadChildren: 'app/modules/riscossione-coattiva/core.module#CoreModule' },
    { path: 'login', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'register', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'backend', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'conversazioni', loadChildren: 'app/modules/riscossione-coattiva/core.module#CoreModule' },
    { path: 'conversazioni/:id', loadChildren: 'app/modules/riscossione-coattiva/core.module#CoreModule' },
    { path: 'dashboard', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'profilo-utente', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'pratiche', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'anagrafica', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'situazione-contribuente', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'situazione-contribuente/:id', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'gestione-notifiche', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'notifiche-immissione-manuale', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'notifiche-riepilogo', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'notifiche-importazione-file', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'gestione-pagamenti', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'pagamenti-immissione-manuale', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'pagamenti-riepilogo', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'pagamenti-importazione-file', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'statistiche-rendicontazione', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'rendicontazione-generale', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'statistiche-riepilogo', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'statistiche-emissioni', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'statistiche-rate', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'liste-carico', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'import-massivi', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'importa-anagrafica', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'importa-associati', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'importa-intimazioni', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'importa-notifiche', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule'},
    { path: 'importa-postali', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'importa-pratiche', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'impostazioni-comune', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'interessi', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'diritti-oneri', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'messi-notificatori', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'flusso-pratica', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'permessi-utenti', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'tipi-notifica', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'canali-pagamento', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'parametri-generali', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'template', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'sistema', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'gestione-stati', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'gestione-comuni', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'gestione-utenti', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'gestione-ruoli', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: 'gestione-gruppi-templates', loadChildren: 'app/modules/riscossione-coattiva/riscossione-coattiva.module#RiscossioneCoattivaModule' },
    { path: '', redirectTo: 'check-access', pathMatch: 'full' }
];

@NgModule({
	imports: [
		BrowserModule,
		HttpClientModule,
		BrowserAnimationsModule,
		AngularFontAwesomeModule,
		CookieModule.forRoot(),
		ClickOutsideModule,
		RiscossioneCoattivaModule.forRoot(),
		RouterModule.forRoot(appRoutes),
	],
	declarations: [
		AppComponent,
		FloatingTableHeaderDirective,
	],
	providers: [
		{ provide: HTTP_INTERCEPTORS, useClass: RCInterceptor, multi: true },
		NativeWindowService,
		CommonService,
		DbService,
		FilterBoxService,
		ContribuentiService,
		UtentiService,
		ComuniService,
		DataService,
		LocaleService,
		AvanzaPraticheService,
		SocketService,
		AuthService,
		JossoService,
		TableExporterService,
		SimpleMQ,
		FilterPipe,
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
